import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import clsx from 'clsx';

import { api, MasterTableItem } from 'landing-page/helpers';
import { useApi } from 'landing-page/hooks/useApi';

import HeroPlaceholder from './Placeholder';

import './style.css';

interface HeroProps {
  autoFetch?: boolean;
  title?: string;
  subtitle?: string;
  description?: string;
  primaryButton?: {
    label: string;
    href: string;
    variant?: string;
    onClick?: () => void;
  };
  secondaryButton?: {
    label: string;
    href: string;
    variant?: string;
  };
  backgroundImage?: string;
  className?: string;
  heroImage?: string;
}

const Hero: React.FC<HeroProps> = ({
  autoFetch = false,
  title,
  subtitle,
  description,
  primaryButton,
  secondaryButton,
  backgroundImage,
  className,
}) => {

  const style = backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : undefined;
  
  const [heroImage, setHeroImage] = useState<string | null>(null);

  const { data: heroImageData, loading: heroImageLoading, error: heroImageError, execute: fetchHeroImageData } = useApi(api.getMasterTable.bind(api));

  useEffect(() => {
    if (autoFetch && !heroImage) {
      fetchHeroImageData({tipe: 'header_5'});
    } else if (heroImage) {
      setHeroImage(heroImage);
    }
  }, [autoFetch]);

  useEffect(() => {
    if (heroImageData?.data?.data && Array.isArray(heroImageData.data.data)) {
        const filteredItem = heroImageData.data.data.filter((item: MasterTableItem) => 
            item.is_active === 1 || item.is_active === '1'
        );
        if (filteredItem && filteredItem.length > 0) {
            setHeroImage(filteredItem[0].image);
        }
    }
}, [heroImageData]);


  if (heroImageLoading) {
    return <HeroPlaceholder />;
  }

  return (
    <section
      id="hero"
      className={clsx('hero-section', className)}
      style={style}
    >
      <Container className='py-10 mt-15' style={{ minHeight: '400px' }}>
        <Row className="align-items-center">
          <Col lg={8} className="text-center text-lg-start">
            <div className="hero-content">
              <h6 className="text-light fw-bold mb-3" style={{textTransform: 'unset'}}>{title}</h6>
              <h1 className="display-4 fw-bold mb-4 text-gray-200" style={{textTransform: 'unset'}}>{subtitle}</h1>
              {description && (
                <p className="lead text-muted mb-5 text-gray-200">{description}</p>
              )}

              <div className='d-flex flex-row gap-5 justify-content-center justify-content-lg-start mb-5'>
                {/* alumni unggulan */}
                <div className='d-flex flex-row gap-0 gap-md-2'>
                  <div className='pt-2'>
                    <span className='d-flex justify-content-center align-items-center' style={{width: '40px', height: '40px', backgroundColor: 'rgba(255, 246, 245, 0.5)', borderRadius: '50%'}}>
                      <i className='bi bi-eye text-primary fs-1' />
                    </span>
                  </div>

                  <div className='d-flex flex-column justify-content-center align-items-start align-items-md-center m-0'>
                    <p className='fw-bold text-light fs-1'>80+</p>
                    <p className='text-gray-200 fs-3 fw-light m-0 text-start text-md-center'>Alumni Unggulan</p>
                  </div>
                </div>

                <div className='d-flex flex-row gap-0 gap-md-2'>
                  <div className='pt-2'>
                    <span className='d-flex justify-content-center align-items-center' style={{width: '40px', height: '40px', backgroundColor: 'rgba(255, 246, 245, 0.5)', borderRadius: '50%'}}>
                      <i className='bi bi-globe text-primary fs-1' />
                    </span>
                  </div>

                  <div className='d-flex flex-column justify-content-center align-items-start align-items-md-center m-0'>
                    <p className='fw-bold text-light fs-1'>50+</p>
                    <p className='text-gray-200 fs-3 fw-light m-0 text-start text-md-center'>Negara Studi</p>
                  </div>
                </div>

                <div className='d-flex flex-row gap-0 gap-md-2'>
                  <div className='pt-2'>
                    <span className='d-flex justify-content-center align-items-center' style={{width: '40px', height: '40px', backgroundColor: 'rgba(255, 246, 245, 0.5)', borderRadius: '50%'}}>
                      <i className='bi bi-graph-up-arrow text-primary fs-1' />
                    </span>
                  </div>

                  <div className='d-flex flex-column justify-content-center align-items-start align-items-md-center m-0'>
                    <p className='fw-bold text-light fs-1'>95%</p>
                    <p className='text-gray-200 fs-3 fw-light m-0 text-start text-md-center'>Tingkat Keberhasilan</p>
                  </div>
                </div>
              </div>
              
              {/* <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-start">
                {primaryButton && (
                  <Button
                    href={primaryButton?.href}
                    variant={primaryButton?.variant}
                    size="lg"
                    className='rounded-5'
                    onClick={primaryButton?.onClick}
                  >
                    {primaryButton?.label}
                  </Button>
                )}
                
                {secondaryButton && (
                  <Button
                    href={secondaryButton?.href}
                    variant={secondaryButton?.variant}
                    size="lg"
                  >
                    {secondaryButton?.label}
                  </Button>
                )}
              </div> */}
            </div>
          </Col>
          
          {/* <Col lg={4} className="text-center">
            <div className="hero-image">
              {heroImage && (
                <img src={heroImage} alt="Hero Image" className="img-fluid rounded-3" style={{width: '100%', height: '100%', objectFit: 'cover'}} />
              )}
            </div>
          </Col> */}
        </Row>
      </Container>
    </section>
  );
};

export default Hero;